// 10/09 (Josh): Signport (his e-signature platform) is reached from the landing page THROUGH the PFS login —
// the tile goes to /signport (a protected route) which forwards to the Signport URL once the session is valid.
// URL from REACT_APP_SIGNPORT_URL (Railway APP service); the fallback is the backend's documented SIGNPORT_BASE_URL.
export const SIGNPORT_URL = process.env.REACT_APP_SIGNPORT_URL || 'https://signport-merchant-contracts.jkhali.chatgpt.site';
